/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeviceWithDeploymentDto } from './deviceWithDeploymentDto';


export interface PositionRequestDto { 
    orderBy?: string;
    orderDirection?: string;
    afterUTC?: string;
    beforeUTC?: string;
    afterSCTS?: string;
    beforeSCTS?: string;
    originCodes?: Array<PositionRequestDto.OriginCodesEnum>;
    deviceIds?: Array<number>;
    animalIds?: Array<number>;
    devicesWithDeployments?: Array<DeviceWithDeploymentDto>;
    page?: number;
    count?: number;
    lastX?: number;
    gtId?: number;
    columnKeywordsList?: Array<string>;
    extendedMessageTypes?: Array<PositionRequestDto.ExtendedMessageTypesEnum>;
    sensorIDCodes?: Array<number>;
    deployedOnly?: boolean;
    fixTypeSearch?: Array<PositionRequestDto.FixTypeSearchEnum>;
    mortalityStatusCodes?: Array<PositionRequestDto.MortalityStatusCodesEnum>;
    showInvalidPositions?: boolean;
    minLatitude?: number;
    maxLatitude?: number;
    minLongitude?: number;
    maxLongitude?: number;
    minAltitude?: number;
    maxAltitude?: number;
}
export namespace PositionRequestDto {
    export const OriginCodesEnum = {
        Globalstar: 'GLOBALSTAR',
        Iridium: 'IRIDIUM',
        GsmSms: 'GSM_SMS',
        GsmFtp: 'GSM_FTP',
        Terminal: 'TERMINAL',
        Collar: 'COLLAR',
        NbIot: 'NB_IOT',
        IridiumEmail: 'IRIDIUM_EMAIL'
    } as const;
    export type OriginCodesEnum = typeof OriginCodesEnum[keyof typeof OriginCodesEnum];
    export const ExtendedMessageTypesEnum = {
        NoContact: 'NO_CONTACT',
        Mortality: 'MORTALITY',
        Status: 'STATUS',
        Null: 'NULL',
        Expelled: 'EXPELLED'
    } as const;
    export type ExtendedMessageTypesEnum = typeof ExtendedMessageTypesEnum[keyof typeof ExtendedMessageTypesEnum];
    export const FixTypeSearchEnum = {
        NoFix: 'NO_FIX',
        OneGpsSat: 'ONE_GPS_SAT',
        TwoGpsSat: 'TWO_GPS_SAT',
        TwoDFix: 'TWO_D_FIX',
        ThreeDFixNotValidated: 'THREE_D_FIX_NOT_VALIDATED',
        ThreeDFixValidated: 'THREE_D_FIX_VALIDATED'
    } as const;
    export type FixTypeSearchEnum = typeof FixTypeSearchEnum[keyof typeof FixTypeSearchEnum];
    export const MortalityStatusCodesEnum = {
        NotAvailable: 'NOT_AVAILABLE',
        NothingDetected: 'NOTHING_DETECTED',
        LowActivityNoRadius: 'LOW_ACTIVITY_NO_RADIUS',
        LowActivityInsideRadius: 'LOW_ACTIVITY_INSIDE_RADIUS',
        LowActivityOutsideRadius: 'LOW_ACTIVITY_OUTSIDE_RADIUS',
        MortalityNoRadius: 'MORTALITY_NO_RADIUS',
        MortalityInsideRadius: 'MORTALITY_INSIDE_RADIUS',
        MortalityOutsideRadius: 'MORTALITY_OUTSIDE_RADIUS'
    } as const;
    export type MortalityStatusCodesEnum = typeof MortalityStatusCodesEnum[keyof typeof MortalityStatusCodesEnum];
}


export type FixTypeSearchEnum = typeof PositionRequestDto.FixTypeSearchEnum[keyof typeof PositionRequestDto.FixTypeSearchEnum];
export type MortalityStatusCodesEnum = typeof PositionRequestDto.MortalityStatusCodesEnum[keyof typeof PositionRequestDto.MortalityStatusCodesEnum];
